import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { Amount } from '@namespace/common';

import styles from './index.module.css';

export const BonusProgressDetails = ({
  detailsList = [],
  className = '',
  status = ''
}) => (
  <ul
    data-testid="bonus-progress-details"
    className={`${className} ${styles.detailsDescription}`}
  >
    {detailsList.map(
      ({
        name,
        value,
        isBonusAmount,
        isAlwaysWithoutOpacity = false,
        isNotDisabled
      }) => (
        <li
          key={`${name} ${value}`}
          className={clsx([
            styles.detailsDescriptionItem,
            styles[`card_${status}`] || '',
            isAlwaysWithoutOpacity && styles.noOpacity,
            isNotDisabled && styles.notDisabled
          ])}
        >
          <Box align="center">
            <AText
              breed="R"
              size="s"
              color="po_txt_color_3"
              className={styles.detailsDescriptionItemName}
            >
              {name}
            </AText>

            {isBonusAmount ? (
              <Amount
                amount={value}
                convertedAmountBreed="B"
                currentAmountBreed="B"
                currentCurrencyBreed="B"
                convertedCurrencyBreed="B"
                convertedAmountColor="po_txt_color_1"
                currentAmountColor="po_txt_color_1"
              />
            ) : (
              <AText breed="B" size="s" color="po_txt_color_1">
                {value}
              </AText>
            )}
          </Box>
        </li>
      )
    )}
  </ul>
);
